import React from 'react';
import FetchDataWrapper from '../../../../../../components/FetchDataWrapper';
import { Select } from 'antd';
import { roomStageIdsMap } from '../../../../../../constants/room/lifeCycle';
import { useAvailableStepsQuery } from '../../../../api/availableSteps';

const SelectStep = ({ value, onChange }) => {
  const { data, isFetching, refetch } = useAvailableStepsQuery({
    params: { stageId: roomStageIdsMap.acceptance },
  });

  const steps = getSteps(data);
  const options = Array.isArray(steps) ? steps : [];

  return (
    <FetchDataWrapper
      data={steps}
      isFetching={isFetching}
      refetch={refetch}
      fetchErrMsg={
        data?.message ?? 'Не удалось загрузить список доступных этапов'
      }
    >
      <Select value={value} onChange={onChange} style={{ width: '100%' }}>
        {options.map((option) => (
          <Select.Option key={option.id} value={option.id}>
            {option.name}
          </Select.Option>
        ))}
      </Select>
    </FetchDataWrapper>
  );
};

export default SelectStep;

function getSteps(data) {
  if (!data || data === 'Error') {
    return data;
  }

  if (!data.success) {
    return 'Error';
  }

  return data.stepsAddressLifeCycle;
}
